





















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { getLabelCategory, addLabel } from '@/api/files/files-base/filesBase'

@Component({
  name: 'label-group'
})
export default class extends Vue {
  @Prop({ required: true }) tags!: Array<any>
  private addParams = {
    id: 0,
    name: '',
    category: 1
  }
  private addFormVisible: boolean = false
  private rules: any = {
    name: [{ required: true, message: '请输入标签名', trigger: 'blur' }],
    category: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }
  private cateList: ISelectItem[] = []
  private tagList: any[] = []
  // lifecycle
  // methodss
  async getLabelCategory() {
    let res = await getLabelCategory()
    this.cateList = res.data
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(async valid => {
      if (valid) {
        let res: any = await addLabel(this.addParams)
        if (res.status.code === 0) {
          this.tags.push(...res.data)
          this.$emit('update:dynamic-tags', this.tags)
          this.addFormVisible = false;
          (this.$refs['addParams'] as Form).resetFields()
        } else {
          this['$message'].error('标签添加失败')
        }
      } else {
        this['$message'].error('参数错误')
        return false
      }
    })
  }
  handleClose(tag: any) {
    console.log(tag)
    for (let i = 0; i < this.tags.length; i++) {
      if (this.tags[i].id === tag.id) {
        this.tags.splice(i, 1)
      }
    }
    this.$emit('update:dynamic-tags', this.tags)
  }

  showAdd() {
    this.addFormVisible = true
    this.getLabelCategory()
  }
}
